import type { ErrorComponentProps } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { ErrorState } from "@/components/shared/error-state";
import { SessionUnknownError } from "@/lib/session-cache";

/** Shown if the sign-in check takes a while, which it does when it is waiting out a rate limit. */
export function SessionChecking() {
  return (
    <div
      data-testid="session-checking"
      className="flex h-screen items-center justify-center gap-2 text-sm text-muted-foreground"
    >
      <Loader2 className="size-4 animate-spin" />
      Checking your sign-in
    </div>
  );
}

/** The check never got an answer. That is not "signed out", so this is not the sign-in page. */
export function SessionCheckFailed({ error }: ErrorComponentProps) {
  return (
    <div data-testid="session-check-failed" className="flex h-screen items-center justify-center">
      <ErrorState
        message={
          error instanceof SessionUnknownError
            ? "We could not check your sign-in just now. You have not been signed out."
            : undefined
        }
        onRetry={() => window.location.reload()}
      />
    </div>
  );
}
